import { breakpoints, colors, fonts, pxToCssFont, pxToRem } from '@vfit/shared/themes';
import styled from 'styled-components';

export const AnchorsContainer = styled.div`
  display: flex;
  margin-top: ${pxToRem(32)};
  column-gap: ${pxToRem(16)};
  row-gap: ${pxToRem(24)};
  flex-flow: wrap;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  @media (min-width: ${breakpoints.tablet}) {
    gap: ${pxToRem(24)};
    margin-top: ${pxToRem(32)};
  }
  @media (min-width: ${breakpoints.desktop}) {
    gap: ${pxToRem(32)};
    margin-top: ${pxToRem(48)};
  }
`;

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  justify-items: center;
  align-items: center;
`;

export const Title = styled.div<{ darkMode?: boolean }>`
  p {
    margin: 0;
    text-align: center;
    font-family: ${fonts.light};
    b {
      font-family: ${fonts.exbold};
      font-weight: 400;
    }
  }
  ${pxToCssFont(28, 36)}
  color: ${({ darkMode }) => (darkMode ? colors.$ffffff : colors.$262626)};
  width: 327px;
  @media (min-width: ${breakpoints.tablet}) {
    ${pxToCssFont(28, 36)}
    width: auto;
  }
  @media (min-width: ${breakpoints.desktop}) {
    margin-top: 0;
    ${pxToCssFont(36, 48)}
    width: auto;
  }
`;
